const appConfig = {
    apiPrefix: '/api',
    authenticatedEntryPath: '/cms/home',
    unAuthenticatedEntryPath: '/cms/sign-in',
    tourPath: '/',
    enableMock: false
}

export default appConfig